import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { SkipLink } from "@/components/ui/skip-link";

interface AuthLayoutProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
}

export function AuthLayout({ children, title, subtitle }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-4 py-12">
      <SkipLink />
      <div id="main-content" tabIndex={-1} className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center">
            <img
              src="/logo.png"
              alt="Brazil Nut AI"
              className="h-10 w-auto brightness-0 invert"
            />
          </Link>
          <h2 className="mt-8 text-3xl font-semibold tracking-tight text-foreground">
            {title}
          </h2>
          {subtitle && (
            <p className="mt-2 text-sm text-muted-foreground">
              {subtitle}
            </p>
          )}
        </div>
        <div className="bg-card shadow-lg rounded-2xl px-8 py-10 border border-border/50">
          {children}
        </div>
      </div>
    </div>
  );
}
